import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import MediaShowPage, {
  MediaTypes
} from '@buyside/components/presentation/MediaShowPage/mediaShowPage';

const VideoShowPageRoot: FC<{ videoId: string }> = ({ videoId }) => {
  if (!videoId) return;

  return (
    <ErrorBoundary pageName="Video Show Page">
      <MediaShowPage id={videoId} mediaType={MediaTypes.VIDEO} />
    </ErrorBoundary>
  );
};

export default VideoShowPageRoot;
